import { pushToGTM } from "@lib/gtmUtility"

const eventObj = {
    eventName: "newGAEvent",
}

const addEvent = ({ label, action, eventName, category }) => {
    eventObj.label = label
    eventObj.action = action
    eventObj.category = category
    if (eventName) eventObj.eventName = eventName
    pushToGTM(eventObj, eventName)
}

export default {
    onTopNavClick: (label) => {
        addEvent({ label, category: "Nav Bar", action: "Top Nav Bar" })
    },
    // Search Bar
    onSearchFocus: (label) => {
        addEvent({
            label,
            category: "Nav Bar",
            action: "Search",
        })
    },
    onClickSuggestion: (label) => {
        addEvent({
            label,
            category: "Search",
            action: "Typeahead",
        })
    },
    onEnterSearch: (label) => {
        addEvent({
            label,
            category: "Search",
            action: "Enter",
        })
    },
    // Location Picker
    onLocationChangeClick: () => {
        addEvent({
            label: "",
            category: "Home",
            action: "Enter your City",
        })
    },
    onCityAutoDetectClick: () => {
        addEvent({
            label: "",
            category: "Home",
            action: "Click on city autodetect",
        })
    },
    onSelectingCity: (label) => {
        addEvent({
            label,
            category: "Home",
            action: "City",
        })
    },
    // Category Tree
    onUdpDesktopClick: (label) => {
        addEvent({
            label,
            action: "click",
            eventCategory: "UDP_desktop",
        })
    },
}
